import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, ArrowDownIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { QuoteOverlay } from './QuoteOverlay';
const heroImages = ['https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1600&q=80', 'https://cdn.magicpatterns.com/uploads/254gsweUo5hVSPSHyEupQB/HVAC.jpg', 'https://cdn.magicpatterns.com/uploads/2kN7V4j6E8Ra5mMH83Bzov/mfm.webp', 'https://cdn.magicpatterns.com/uploads/3XW5NpAMJMCuH3srhXLsXz/office.png'];
export function HeroV2() {
  const [currentImage, setCurrentImage] = useState(0);
  const [isQuoteOverlayOpen, setIsQuoteOverlayOpen] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative h-screen min-h-[600px] md:min-h-[700px] overflow-hidden" data-id="element-265">
      {/* Background images — z-0 */}
      <div className="absolute inset-0" data-id="element-266">
        <AnimatePresence mode="popLayout" data-id="element-267">
          <motion.img key={currentImage} src={heroImages[currentImage]} alt="Commercial HVAC installation" className="absolute inset-0 w-full h-full object-cover" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 1.2,
          ease: 'easeInOut'
        }} data-id="element-268" />
        </AnimatePresence>
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-primary-dark/55" data-id="element-269"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-primary-dark/70 via-primary-dark/20 to-primary-dark/60" data-id="element-270"></div>

      {/* All foreground content */}
      <div className="relative z-10 h-full flex flex-col" data-id="element-271">
        {/* Spacer for fixed nav */}
        <div className="shrink-0 h-24 md:h-28" data-id="element-272"></div>

        {/* Hero content — center-left */}
        <div className="flex-1 flex flex-col justify-end px-8 md:px-12 lg:px-16 pb-16 md:pb-20 min-h-0" data-id="element-273">
          <div className="max-w-4xl" data-id="element-274">
            <motion.h1 initial={{
            opacity: 0,
            y: 40
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.9,
            delay: 0.3
          }} className="text-5xl md:text-7xl lg:text-8xl text-white font-serif leading-[1.05] mb-8 tracking-tight" data-id="element-275">
              Commercial AC
              <br data-id="element-276" />
              installation &<br data-id="element-277" />
              maintenance
            </motion.h1>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.5
          }} data-id="element-278">
              <button onClick={() => setIsQuoteOverlayOpen(true)} className="hero-cta gap-4 group" data-id="element-279">
                <span className="text-sm font-medium" data-id="element-280">Get a free quote</span>
                <div className="relative z-10 w-10 h-10 bg-white/10 rounded-full flex items-center justify-center transition-all duration-500 group-hover:bg-white/20" data-id="element-281">
                  <ArrowRight className="w-5 h-5 text-white -rotate-45 group-hover:rotate-0 transition-transform duration-500" data-id="element-282" />
                </div>
              </button>
            </motion.div>
          </div>
        </div>

        {/* Bottom bar — tagline left, discover more right */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="px-8 md:px-12 lg:px-16 pb-8 md:pb-10 flex justify-between items-end shrink-0" data-id="element-283">
          <div className="text-white/60 text-sm leading-relaxed" data-id="element-284">
            Nationwide Daikin D1+ Premier Partners.
            <br data-id="element-285" />
            Based in Coventry, West Midlands.{' '}
            <Link to="/areas-we-cover" className="text-accent hover:text-white transition-colors underline underline-offset-4 decoration-accent/30" data-id="element-286">
              View all areas we cover
            </Link>
          </div>

          <motion.a href="#partner-logos" className="hidden md:flex flex-col items-center gap-2 text-white/60 hover:text-white text-xs uppercase tracking-widest transition-colors group" whileHover={{
          y: 5
        }} transition={{
          type: 'spring',
          stiffness: 400,
          damping: 17
        }} data-id="element-287">
            <span className="font-semibold" data-id="element-288">Discover more</span>
            <motion.div animate={{
            y: [0, 8, 0],
            opacity: [0.4, 1, 0.4]
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="bg-white/10 p-2 rounded-full border border-white/10 group-hover:bg-accent group-hover:border-accent transition-colors" data-id="element-289">
              <ArrowDownIcon className="w-4 h-4" data-id="element-290" />
            </motion.div>
          </motion.a>
        </motion.div>
      </div>

      <QuoteOverlay isOpen={isQuoteOverlayOpen} onClose={() => setIsQuoteOverlayOpen(false)} data-id="element-291" />
    </section>;
}